import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBluelagoon } from "@bluelagoon";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";

export default function SSOTestButton({ disabled }) {
    const { t } = useTranslation();
    const { call: testSSO, isLoading } = useBluelagoon({ method: "testSSOConfig" });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const testResult = params.get("sso_test");
        if (testResult === "success") {
            const email = params.get("email");
            toast.success(t("ssoSettings.testSuccess", { email }));
            window.history.replaceState({}, "", window.location.pathname);
        } else if (testResult === "error") {
            const message = params.get("message");
            toast.error(message || t("ssoSettings.testError"));
            window.history.replaceState({}, "", window.location.pathname);
        }
    }, [t]);

    const handleTest = async () => {
        try {
            const res = await testSSO({});
            if (res?.data?.authUrl) {
                const width = 600;
                const height = 700;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;
                window.open(res.data.authUrl, "sso_test", `width=${width},height=${height},left=${left},top=${top}`);
            } else {
                toast.error(res?.error || t("ssoSettings.testError"));
            }
        } catch (err) {
            toast.error(err?.message || t("ssoSettings.testError"));
        }
    };

    return (
        <button type="button" onClick={handleTest} disabled={disabled || isLoading}
            className="inline-flex items-center gap-1.5 border border-gray-300 text-gray-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <FlaskConical className="w-4 h-4" />
            {isLoading ? t("ssoSettings.testing") : t("ssoSettings.testSSO")}
        </button>
    );
}
